import { isProductEnabled } from "@/business/product-access";
import { isAdminOrOwner } from "@/user/utils";

/**
 * The feature's public surface. The nav bar and the route guard need to know
 * where profitability lives and who may see it; nothing else in this module is
 * theirs to import.
 */
export const PROFITABILITY_PATH = "/profitability";

export const profitabilityRunPath = (runId: string) =>
  `${PROFITABILITY_PATH}/${runId}`;

export const isProfitabilityPath = (path: string) =>
  path === PROFITABILITY_PATH || path.startsWith(`${PROFITABILITY_PATH}/`);

/**
 * Mirrors `User#can_manage_finances?` on the API, which is what actually gates
 * these endpoints. Keep the two in step: a looser rule here shows a tab that
 * 403s, a tighter one hides a report the user is entitled to.
 */
export const canAccessProfitability = (
  user: { role?: string; parentable_type?: string } | null | undefined,
) =>
  !!user &&
  (user.parentable_type?.toUpperCase() === "TENANT" ||
    isAdminOrOwner(user.role));

/**
 * Whether the tab can open reports. Access is not enough: a business with no
 * published report script has nothing behind the tab, and the empty state would
 * invite a report the API then refuses.
 */
export const canOpenProfitabilityReports = (
  user: { role?: string; parentable_type?: string } | null | undefined,
  business:
    | {
        has_published_profitability_script?: boolean;
        enabled_products?: unknown;
      }
    | null
    | undefined,
) =>
  isProductEnabled(business?.enabled_products, "profitability") &&
  canAccessProfitability(user) &&
  !!business?.has_published_profitability_script;
